import PropTypes from 'prop-types';
import {createUseStyles, useTheme} from 'react-jss';
import MessageType from '../../enums/MessageType';
import setContrastColorBasedOnBackground from '../../v2/style-helper/setContrastColorBasedOnBackground';

const setArtemisIconFill = props => (
  (props.isArtemisIcon && props.theme.colors?.[MessageType.SUCCESS]?.base)
    ? props.theme.colors[MessageType.SUCCESS].base
    : props.theme.core.messageColours[MessageType.SUCCESS].foreground);

const setBrandIcon = props => ((props.isArtemisIcon && props.theme.selectedFieldHighlightOverride)
  || props.theme.selectedFieldHighlight);

const useStyles = createUseStyles({
  icon: {
    fill: props => (props.brand ? setBrandIcon(props) : setArtemisIconFill(props)),
    verticalAlign: 'middle',
    marginBottom: 4,
  },
  circle: {
    backgroundColor: props => props.monotoneCheck && setContrastColorBasedOnBackground(setBrandIcon(props)),
    width: 18,
    height: 18,
    borderRadius: 10,
    position: 'absolute',
    margin: 'auto',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: -1,
  },
});

export default function CheckIcon(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
    
  return (
    <>
      <svg width={24} height={24} className={classes.icon} viewBox="0 0 24 24" role="presentation">
        <path
          d={'M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm5.293-14.707l-7.29 '
          + '7.293-3.296-3.293-1.414 1.414 4.71 4.707 8.704-8.707-1.414-1.414z'}
        />
      </svg>
      <div className={classes.circle} />
    </>
  );
}

CheckIcon.propTypes = {
  brand: PropTypes.bool,
  monotoneCheck: PropTypes.bool,
  isArtemisIcon: PropTypes.bool,
};

CheckIcon.defaultProps = {
  brand: true,
  monotoneCheck: false,
};
